import './charts/rigsate/rigstate'
import './charts/rig-indicators/rig-indicators'
import './charts/imagelog/imagelog'
import './charts/lithology/lithology'
import './charts/messages/message'
import './charts/bha'
import './charts/wbs'
import './charts/trajectory'
import './charts/connection-fingerprint'

import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import pt_br from '../js/i18n/pt_br'
import en_us from '../js/i18n/en_us'

const localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}

// register current locale file
i18n.add(localeFiles[locale])
